import { render, staticRenderFns } from "./FrontPageAd.vue?vue&type=template&id=b4a9a296&scoped=true"
import script from "./FrontPageAd.vue?vue&type=script&lang=js"
export * from "./FrontPageAd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4a9a296",
  null
  
)

export default component.exports